export default "__VITE_ASSET__Cqt0gQXx__"